export const APP_NAME = 'Elstar';
export const PERSIST_STORE_NAME = 'admin';
export const REDIRECT_URL_KEY = 'redirectUrl';

export const statusColor = {
  0: {
    label: 'inactive',
    dotClass: 'bg-gray-300',
    textClass: 'text-gray-300',
  },
  1: {
    label: 'active',
    dotClass: 'bg-emerald-500',
    textClass: 'text-emerald-500',
  },
};

export const orderStatusColor = {
  NEW: {
    label: 'new',
    dotClass: 'bg-amber-500',
    textClass: 'text-amber-500',
    bgClass: 'bg-amber-100',
  },
  CONFIRMED: {
    label: 'confirmed',
    dotClass: 'bg-pink-500',
    textClass: 'text-pink-500',
    bgClass: 'bg-pink-100',
  },
  READY: {
    label: 'ready',
    dotClass: 'bg-emerald-500',
    textClass: 'text-emerald-500',
    bgClass: 'bg-emerald-100',
  },
  SHIPPED: {
    label: 'shipped',
    dotClass: 'bg-blue-500',
    textClass: 'text-blue-500',
    bgClass: 'bg-blue-100',
  },
  RETURNED: {
    label: 'returned',
    dotClass: 'bg-red-300',
    textClass: 'text-red-300',
    bgClass: 'bg-red-100',
  },
  CANCELED: {
    label: 'cancelled',
    dotClass: 'bg-red-500',
    textClass: 'text-red-500',
    bgClass: 'bg-red-100',
  },
  DELIVERED: {
    label: 'delivered',
    dotClass: 'bg-green-500',
    textClass: 'text-green-500',
    bgClass: 'bg-green-100',
  },
  NO_ANSWER: {
    label: 'noAnswer',
    dotClass: 'bg-gray-500',
    textClass: 'text-gray-500',
    bgClass: 'bg-gray-100',
  },
  FOR_COLLECT: {
    label: 'forCollect',
    dotClass: 'bg-gray-500',
    textClass: 'text-gray-500',
    bgClass: 'bg-gray-100',
  },
};

export const invoiceStatusColor = {
  NEW: {
    label: 'new',
    dotClass: 'bg-amber-500',
    textClass: 'text-amber-500',
  },
  PAYED: {
    label: 'paid',
    dotClass: 'bg-green-500',
    textClass: 'text-green-500',
  },
};

export const languageList = [
  { label: 'English', value: 'en', flag: 'uk' },
  { label: 'Latvian', value: 'lv', flag: 'lv' },
  { label: 'Lithuanian', value: 'lt', flag: 'lt' },
  { label: 'Estonian', value: 'et', flag: 'et' },
  { label: 'Russian', value: 'ru', flag: 'ru' },
];
